module.exports = __webpack_public_path__ + "static/media/logonobg.7dc965cd.png";